<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="990"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItemsAuto"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--打印付款清单-->
          <el-button type="primary" no="1" @click="printClickHandler">{{ $t('CargoMsg.Cargo_PrintPaymentList') }}</el-button>
          <!--审核   -->
          <el-button v-show="$checkPermission(['button_SingleReleaseHBL_audit'])" type="primary" no="2" @click="btnAuditClickHandler">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
          <!--撤销审核   -->
          <el-button v-show="$checkPermission(['button_SingleReleaseHBL_audit'])" type="primary" no="3" @click="btnCancelAuditClickHandler">{{ $t('CargoMsg.Cargo_RevokeReview') }}</el-button>
          <!--扣单   -->
          <el-button v-show="$checkPermission(['button_SingleReleaseHBL_detain'])" type="primary" no="4" @click="btnDetainClickHandler">{{ $t('CargoMsg.Cargo_HoldDoc') }}</el-button>
          <!-- 特批放单 -->
          <el-button v-show="$checkPermission(['button_SingleReleaseHBL_specialApproval'])" no="specialApproval" type="primary" @click="btnSpecialApprovalClickHandler">{{ $t('CargoMsg.Cargo_SpecialApprovalOrder') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="height: 40%">
        <cargo-ag-grid
          config-module="990002"
          :grid-options="audit.gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefsAuto"
          :row-data="audit.rowData"
          :grid-params.sync="audit.gridParams"
          style="width: 100%; min-height: 200px"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="990001"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
      <div class="section grid-wrapper" style="height: 30%">
        <cargo-ag-grid
          config-module="990020"
          :grid-options="selectShow.gridOptions"
          :column-defs="columnDef"
          :row-data="selectShow.rowData"
          :grid-params.sync="selectShow.gridParams"
          style="width: 100%;height: 100%"
          @gridReady="onSelectShowGridReady"
        />
      </div>
    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!--    扣单 -->
    <withhold-reason-window
      :visible.sync="withOldWindow.visible"
      :list="withOldWindow.list"
      @saveWithholdReasonHandler="saveWithholdReasonHandler"
    />
    <!-- 放单规则校验结果 -->
    <release-rule-result-window
      v-if="releaseRuleResultWindow.visible"
      :visible.sync="releaseRuleResultWindow.visible"
      :release-rules="releaseRuleResultWindow.releaseRules"
      @close="releaseRuleResultWindow.visible=false"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!--保函上传文件-->
    <guarantee-file-dialog
      :visible.sync="guaranteeFileDialog.visible"
      :model="guaranteeFileDialog.model"
      :title="$t('Message.fileManagement')"
      :if-long-guarantee-state="guaranteeFileDialog.ifLongGuaranteeState"
      @saveCallBack="toQueryByPage"
    />
    <el-dialog
      :close-on-click-modal="false"
      class="conf-dialog"
      :visible.sync="longTermGuaranteeFileDialog.visible"
      :title="$t('Message.fileManagement')"
      width="750px"
    >
      <guarantee-file-history-tab
        ref="file-history"
        :lazy="true"
        :context="this"
        :uuid="longTermGuaranteeFileDialog.uuid"
        :button-show="false"
      />
    </el-dialog>

  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import {
  BUCKLERELEASE,
  NOTSINGLERELEASE,
  SINGLERELEASE
} from '@/class/cargo/model/parameters/ReleaseState'
import {
  batchAuditSingleReleaseHbl,
  checkCustomsBlackName,
  loadCargoDocKeysByReleaseReview,
  loadChargesFunc,
  querySingleReleaseVerifyPageableFunc,
  specialApprovalOrder,
  updateChargeAndDocFunc
} from '@/api/seaExport/cargoDoc'
import {
  CARGODOC_CAN_SINGLE_RELEASE,
  CARGODOC_CANCEL_APPROVE,
  CARGODOC_DETAIN
} from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as trackingApi from '@/api/sysManage/baseConfig/businessManage'
import { EX_MBL_EXAMINE } from '@/class/cargo/model/parameters/TrackingConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import WithholdReasonWindow from '@/views/cargo/v0/Clearing/components/releaseControl/withholdReasonWindow'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { HBL } from '@/class/cargo/model/parameters/CargoDocConsts'
import DateUtils from '@/utils/dateUtils'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ReleaseRuleResultWindow from '@/views/cargo/v0/Clearing/components/releaseControl/releaseRuleResultWindow'
import { recordSelectedStatus } from '@/utils/agGrid'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import { MODE_AUDIT } from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import OperationRender from '@/components/OperationRender/index'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import GuaranteeFileDialog from '@/components/Cargo/FileUpload/guaranteeFileDialog.vue'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as ExternalFileType from '@/class/cargo/model/parameters/ExternalFileType'
import GuaranteeFileHistoryTab from '@/views/cargo/v0/Information/components/guarantee/guaranteeFileHistoryTab.vue'
import { queryReleaseGuaranteeList } from '@/api/sysManage/baseConfig/putASingleRule'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'SingleReleaseVerifyViewHbl',
  components: {
    GuaranteeFileHistoryTab,
    GuaranteeFileDialog,
    BatchCheckingWindow,
    WithholdReasonWindow,
    searchItem,
    cargoTemplateSelectorDialog,
    ReleaseRuleResultWindow
  },
  props: {
    arWriteOffStatusQuerySearch: { type: Boolean, default: false }, // 子应用应收核销状态查询条件/显示列
    arWriteOffStatusQueryColumn: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      documentManage: new DocumentManage(),
      bankAccounts: null,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        lob: '',
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageCount: 0,
      audit: {
        selectedData: null,
        selectedFiles: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onGridCellFocused(event)
          },
          // 行点击事件
          onRowClicked: this.onRowClicked,
          // 行勾选事件
          onRowSelected: this.onRowSelected,
          defaultColDef: {
            resizable: true
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      selectShow: {
        selectedData: null,
        gridParams: {},
        gridOptions: {
          getRowStyle: (params) => {
            const row = params.data
            if (row.receivable) {
              return { 'color': '#078707' }
            } else {
              return { 'color': '#E00A29FF' }
            }
          }
        },
        rowData: [],
        nowJob: null,
        gridApi: null
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CargoDocList',
        data: {}
      },
      withOldWindow: {
        visible: false,
        list: []
      },
      sopJobs: [],
      releaseRuleResultWindow: {
        visible: false,
        releaseRules: []
      },
      guaranteeFileDialog: {
        visible: false,
        model: {},
        ifLongGuaranteeState: false
      },
      longTermGuaranteeFileDialog: {
        visible: false,
        uuid: ''
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.showBusinessInfo
            }
          }
        },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerChineseName', width: 100, colId: 'customerChineseName' },
        { headerName: this.$t('CargoMsg.Cargo_ConsignorSCode'), field: 'customerCnShortName', width: 100, colId: 'customerCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_AbbreviationOfConsignor'), field: 'customerShortName', width: 100, colId: 'customerShortName' },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'creditPeriod', width: 100, colId: 'creditPeriod',
          cellRenderer: (params) => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CreditUsed'), field: 'creditUsed', width: 100, colId: 'creditUsed',
          cellRenderer: (params) => {
            return ColumnUtils.creditUsedCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.creditUsedCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgent'), field: 'bookingAgentChineseName', width: 100, colId: 'bookingAgentChineseName' },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgentCode'), field: 'bookingAgentCnShortName', width: 100, colId: 'bookingAgentCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgentAbbreviation'), field: 'bookingAgentShortName', width: 100, colId: 'bookingAgentShortName' },
        { headerName: this.$t('CargoMsg.Cargo_CarrierShip'), field: 'carrierChineseName', width: 100, colId: 'carrierChineseName' },
        { headerName: 'SO NO.', field: 'soNoStr', width: 100, colId: 'soNoStr',
          tooltipValueGetter: (params) => params.value
        },
        { headerName: this.$t('CargoMsg.Cargo_ShippingCompanySCode'), field: 'carrierCnShortName', width: 100, colId: 'carrierCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_ShippingCompanySAbbreviation'), field: 'carrierShortName', width: 100, colId: 'carrierShortName' },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'dischargingPortCode', width: 100, colId: 'dischargingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETD'), field: 'etd', width: 100, colId: 'etd',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'eta', width: 100, colId: 'eta',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ATD'), field: 'atd', width: 100, colId: 'atd',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ATA'), field: 'ata', width: 100, colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VesselAndVoyage'),
          field: 'voyageFlightStr',
          width: 100,
          colId: 'voyageFlightStr'
        },
        { headerName: 'MB/L', field: 'mblNo', width: 100, colId: 'mblNo' },
        { headerName: 'HBL NO', field: 'hblInfo', width: 100, colId: 'hblInfo' },
        { headerName: this.$t('CargoMsg.Cargo_HBLMode'), field: 'releaseType', width: 100, colId: 'releaseType',
          cellRenderer: params => {
            return ColumnUtils.getHBLBillReleaseTypeByCode(BlModeType.HBL.code, params.data.releaseType)
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.getHBLBillReleaseTypeByCode(BlModeType.HBL.code, params.data.releaseType)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DocumentationType'), field: 'customerSelfRelease', width: 100, colId: 'customerSelfRelease',
          cellRenderer: (params) => {
            if (params.value === 1) {
              return this.$t('CargoMsg.Cargo_CustomerSelfRelease')
            } else if (params.value === 2) {
              return this.$t('CargoMsg.Cargo_CompanySelfRelease')
            } else {
              return ''
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessStatus'), field: 'jobState', width: 100, colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'sales', width: 100, colId: 'sales',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesDepartment'), field: 'salesDepartment', width: 100, colId: 'salesDepartment',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'), field: 'salesOffice', width: 100, colId: 'salesOffice',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_HblCheckingStatus'), field: 'cfmState', width: 100, colId: 'cfmState',
          cellRenderer: (params) => {
            return ColumnUtils.cfmStatusLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.HBLReleasingStatus'), field: 'releaseState', width: 100, colId: 'releaseState',
          cellRenderer: params => {
            const releaseState = ReleaseState.getReleaseStateByCode(params.value)
            if (releaseState) {
              return this.$store.getters.language === 'zh' ? releaseState.chineseName : releaseState.englishName
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReviewTime'), field: 'reviewDate', width: 100, colId: 'reviewDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentTime'), field: 'agreePayDate', width: 100, colId: 'agreePayDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TimeOfDocHolding'), field: 'withholdDate', width: 100, colId: 'withholdDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_2NdReleaseTime'), field: 'secondReleaseDate', width: 100, colId: 'secondReleaseDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReasonOfCargoDetention'), colId: 'withholdReason', field: 'withholdReason', initialWidth: 100,
          valueFormatter: (params) => {
            return params.value
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.changeReleaseReviewHandler(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_ContractValidStatus'), field: 'contractValid', width: 100, colId: 'contractValid',
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DrawABillOrNot'), field: 'makeInvoiceAll', width: 100, colId: 'makeInvoiceAll',
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAll'), field: 'writeOffAll', width: 100, colId: 'writeOffAll',
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'extended', width: 100, colId: 'extended',
          cellRenderer: params => {
            return ColumnUtils.dateExceededCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.dateExceededCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'excessive', width: 100, colId: 'excessive',
          cellRenderer: params => {
            return ColumnUtils.amountExceededCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.amountExceededCommonLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), colId: 'remarks', field: 'remarks', initialWidth: 100,
          valueFormatter: (params) => {
            return params.value
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.changeReleaseReviewHandler(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_ReleasePerson'), field: 'releaseBy', width: 100, colId: 'releaseBy',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Auditor'), field: 'releaseReviewUser', width: 100, colId: 'releaseReviewUser',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.HBLIssueBillLading'), field: 'bliStatus', width: 100, colId: 'bliStatus',
          cellRenderer: (params) => {
            return ColumnUtils.bliStatusLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_BusinessReferenceNo'),
          field: 'customerRefNo',
          width: 200
        },
        { headerName: this.$t('SeaExport.RequestReleaseState'), field: 'requestReleaseState', width: 120, colId: 'requestReleaseState',
          cellRenderer: params => {
            return params.value === 0 ? this.$t('SeaExport.NotApplying') : this.$t('SeaExport.Requested')
          }
        },
        { headerName: this.$t('SeaExport.RequestReleaseDate'), field: 'requestReleaseTime', width: 120, colId: 'requestReleaseTime',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.RequestReleaseBy'), field: 'requestReleaseBy', width: 120, colId: 'requestReleaseBy',
          cellRenderer: params => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.NCReferenceNo'),
          field: 'agentRefNo',
          colId: 'agentRefNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLHBR'),
          field: 'jointMasterHBLJobNo',
          colId: 'jointMasterHBLJobNo',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SerialNo'),
          field: 'serialNo',
          colId: 'serialNo',
          hide: true,
          width: 150
        },
        { headerName: this.$t('CargoMsg.Cargo_HBLType'), field: 'issuerBL', width: 100, colId: 'issuerBL',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', params.value, 'name')
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', params.data.issuerBL, 'name')
          }

        },
        {
          headerName: this.$t('SeaExport.HBLBlProperty'),
          field: 'typeHBL',
          colId: 'typeHBL',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.typeHBLLabelFunc(params.data.typeHBL)
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.typeHBLLabelFunc(params.data.typeHBL)
          }
        },
        {
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          field: 'masterJobNo',
          colId: 'masterJobNo',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          width: 150,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          width: 150,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementType'),
          field: 'settlementType',
          colId: 'settlementType',
          cellRenderer: (params) => {
            return ColumnUtils.settlementTypeCommonLabelFunc(params.data)
          },
          filterParams: {},
          width: 150,
          hide: true,
          filterValueGetter: params => ColumnUtils.settlementTypeCommonLabelFunc(params.data)
        },
        { headerName: this.$t('CargoMsg.Cargo_Documents'),
          field: 'dc',
          colId: 'dc',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'op',
          colId: 'op',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerService'),
          field: 'csr',
          colId: 'csr',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerServiceOverSea'),
          field: 'overseaOp',
          colId: 'overseaOp',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.AirlinePerson2'),
          field: 'planner',
          colId: 'planner',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgentChineseName',
          colId: 'destinationAgentChineseName',
          width: 200
        }, {
          headerName: this.$t('queryJob.nominatedAgent'),
          field: 'designationAgentChineseName',
          colId: 'designationAgentChineseName',
          width: 200
        },
        {
          headerName: this.$t('queryJob.destinationAgentShortName'),
          field: 'destinationAgentShortName',
          colId: 'destinationAgentShortName',
          width: 200
        }, {
          headerName: this.$t('queryJob.nominatedAgentShortName'),
          field: 'designationAgentShortName',
          colId: 'designationAgentShortName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyDateOfCreation'),
          field: 'companyCreateDate',
          colId: 'companyCreateDate',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          colId: 'incoTerm',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          hide: true,
          width: 150
        },
        { headerName: this.$t('CargoMsg.Cargo_ArCustomerPaidOff'), colId: 'arCustomerPaidOff', field: 'arCustomerPaidOff', width: 175, minWidth: 175,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        }
      ],
      guaranteeColumnDef: [
        {
          headerName: this.$t('SeaExport.LongTermGuaranteeState'),
          field: '',
          colId: '',
          hide: true,
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('SeaExport.NoGuarantee'),
                disabled: true,
                visible: (params) => params && params.hasOwnProperty('longTermGuaranteeState') && (params.longTermGuaranteeState === SystemConstants.LONG_TERM_GUARANTEE_STATE_NONE.code)
              },
              {
                title: this.$t('SeaExport.InEffect'),
                disabled: true,
                visible: (params) => params && params.hasOwnProperty('longTermGuaranteeState') && (params.longTermGuaranteeState === SystemConstants.LONG_TERM_GUARANTEE_STATE_INEFFECT.code)
              },
              {
                title: this.$t('SeaExport.View'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.guaranteeFileDialogHandler(params, true)
                },
                visible: (params) => params && params.hasOwnProperty('longTermGuaranteeState') && (params.longTermGuaranteeState === SystemConstants.LONG_TERM_GUARANTEE_STATE_INEFFECT.code)

              },
              {
                title: this.$t('SeaExport.Expired'),
                disabled: true,
                visible: (params) => params && params.hasOwnProperty('longTermGuaranteeState') && (params.longTermGuaranteeState === SystemConstants.LONG_TERM_GUARANTEE_STATE_EXPIRED.code)
              },
              {
                title: this.$t('SeaExport.View'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.guaranteeFileDialogHandler(params, true)
                },
                visible: (params) => params && params.hasOwnProperty('longTermGuaranteeState') && (params.longTermGuaranteeState === SystemConstants.LONG_TERM_GUARANTEE_STATE_EXPIRED.code)
              }
            ]
          }
        },
        {
          headerName: this.$t('SeaExport.SingleTicketGuaranteeState'),
          field: '',
          colId: '',
          hide: true,
          width: 400,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('SeaExport.NotUploadedYetPlease'),
                disabled: true,
                visible: (params) => params && params.hasOwnProperty('singleTicketGuaranteeState') && (params.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED.code)
              },
              {
                title: this.$t('SeaExport.Upload'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.guaranteeFileDialogHandler(params)
                },
                visible: (params) => params && params.hasOwnProperty('singleTicketGuaranteeState') && (params.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED.code)
              },
              {
                title: this.$t('SeaExport.Uploaded'),
                disabled: true,
                visible: (params) => params && params.hasOwnProperty('singleTicketGuaranteeState') && (params.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_UPLOADED.code)
              },
              {
                title: this.$t('SeaExport.View'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.guaranteeFileDialogHandler(params)
                },
                visible: (params) => params && params.hasOwnProperty('singleTicketGuaranteeState') && (params.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_UPLOADED.code)
              },
              {
                title: this.$t('SeaExport.NoUploadRequired'),
                disabled: true,
                visible: (params) => params && params.hasOwnProperty('singleTicketGuaranteeState') && (params.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_NO_REQUIRED.code)
              }
            ]
          }
        }
      ]
    }
  },
  computed: {
    customSearchItemsAuto() {
      return this.initCustomSearchItems()
    },
    columnDefsAuto() {
      if (this.arWriteOffStatusQueryColumn && this.columnDefs.filter(item => ['verifyStateReceivable'].includes(item.field)).length === 0) {
        this.columnDefs.push({ headerName: this.$t('CargoMsg.Cargo_ReceivablesWriteOfStatus'), field: 'verifyStateReceivable', colId: 'verifyStateReceivable', width: 150 })
      }
      return this.columnDefs
    },
    columnDef() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SettlingCompanySCode'), field: 'accountId', width: 160, colId: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'cnShortName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlingCompanySAbbreviation'), field: 'accountId', width: 160, colId: 'accountId',
          cellRenderer: params => {
            if (params.data.receivable) {
              return '<a style="text-decoration: underline">' +
                ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName') + '</a>'
            } else {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
            }
          },
          onCellClicked: (params) => {
            if (params.data.receivable) {
              const companyUuid = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'uuid')
              this.printCompanyClickHandler(companyUuid)
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', width: 100, colId: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'), field: 'receivable', width: 100, colId: 'receivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 100, colId: 'currency' },
        { headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'amount', width: 100, colId: 'amount',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DomesticOrInternational'), field: 'oversea', width: 100, colId: 'oversea',
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TheAmountOfWrittenOff'), field: 'verifiedAmount', width: 100, colId: 'verifiedAmount',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AmountNotWrittenOff'), field: 'verifiedAmount', width: 100, colId: 'verifiedAmount',
          cellRenderer: params => {
            return ColumnUtils.formatNumber((params.data.amount - params.value), 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Payable'), field: 'payable', width: 100, colId: 'payable',
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RelatedBLNo'), field: 'relatedMbl', width: 100, colId: 'relatedMbl' },
        { headerName: this.$t('CargoMsg.Cargo_TypeOfBill'), field: 'actualType', width: 100, colId: 'actualType' },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffNo'), field: 'actualAmountNo', width: 100, colId: 'actualAmountNo' },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', width: 100, colId: 'invoiceNo' },
        {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo') + this.$t('CargoMsg.Cargo_ChineseNamed'),
          field: 'accountId',
          colId: 'accountId',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'businessNo', width: 100, colId: 'businessNo' },
        { headerName: 'HBL NO', field: 'hblNbr2', width: 100, colId: 'hblNbr2' },
        {
          headerName: this.$t('FinanceManage.charge_shared'),
          field: 'shared',
          width: 100,
          hide: true,
          filter: false,
          filterParams: {},
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            const curValue = params.value || (params.data.shareScheme && parseInt(params.data.shareScheme) !== 0)
            return ColumnUtils.booleanLabelFunction(curValue)
          }
        }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    // this.initCustomSearchItems()
    await this.initColumnDefs()
  },
  beforeMount() {
    this.documentManage.set('showBusinessInfo', () => {
      this.showBusinessInfo()
    })
  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.audit.gridApi = p.api
    },
    onSelectShowGridReady(p) {
      this.selectShow.gridApi = p.api
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.jobNo)
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.jobNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.jobNo = ''
      }
      this.doAdvancedQuery(data)
    },
    // 高级查询
    doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', [0, 1, 2, 11, 13], AdvancedSearchConsts.OPERATOR_IN.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      const conditionMap = {}
      let expectDateOption = {}
      // 是否已核销
      if (AdvancedSearchOption.hasField('charge.PAID_OFF', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('charge.PAID_OFF', this.filterJson.conditions)
        conditionMap['paidOff'] = expectDateOption.value
        AdvancedSearchOption.removeOption('charge.PAID_OFF', this.filterJson.conditions)
      }
      // 合约是否有效
      if (AdvancedSearchOption.hasField('isContractValid', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('isContractValid', this.filterJson.conditions)
        conditionMap['isContractValid'] = expectDateOption.value
        AdvancedSearchOption.removeOption('isContractValid', this.filterJson.conditions)
      }
      // 是否开票
      if (AdvancedSearchOption.hasField('isMakeInvoice', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('isMakeInvoice', this.filterJson.conditions)
        conditionMap['isMakeInvoice'] = expectDateOption.value
        AdvancedSearchOption.removeOption('isMakeInvoice', this.filterJson.conditions)
      }
      // 是否全部核销
      if (AdvancedSearchOption.hasField('isWriteOffAll', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('isWriteOffAll', this.filterJson.conditions)
        conditionMap['isWriteOffAll'] = expectDateOption.value
        AdvancedSearchOption.removeOption('isWriteOffAll', this.filterJson.conditions)
      }
      // 是否超期
      if (AdvancedSearchOption.hasField('isExtended', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('isExtended', this.filterJson.conditions)
        conditionMap['isExtended'] = expectDateOption.value
        AdvancedSearchOption.removeOption('isExtended', this.filterJson.conditions)
      }
      // 是否超额
      if (AdvancedSearchOption.hasField('isExcessive', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('isExcessive', this.filterJson.conditions)
        conditionMap['isExcessive'] = expectDateOption.value
        AdvancedSearchOption.removeOption('isExcessive', this.filterJson.conditions)
      }
      conditionMap['docType'] = HBL
      this.filterJson.condition = conditionMap
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.page = 4
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.requires = this.arWriteOffStatusQueryColumn ? ['verifyStateReceivable'] : []
      querySingleReleaseVerifyPageableFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.audit.gridOptions.api, 'uuid')
      if (res.data.list) {
        for (const data of res.data.list) {
          CargoDocUtil.setFieldHandler(data)
        }
      }
      this.handleSopField(res.data.list)
      this.audit.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.audit.selectedData = null
      this.selectShow.rowData = []
      this.selectShow.nowJob = null
      this.audit.gridApi.clearFocusedCell()
      this.loading.close()
      selectedStatus.revert()
    },
    // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
    handleSopField(rowData) {
      for (let i = 0; i < rowData.length; i++) {
        const row = rowData[i] // 当前行
        const currentJobSopState = row.sopState // 当前行的SOP数据
        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // console.log('==========tracks===========', tracks)
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? '' : oldColumnValue
          //
          const columnField = '_sop_' + columnName
          rowData[i][columnField] = columnValue
        }
      }
    },
    onRowClicked(event) {
      this.doRowClicked(event, true)
    },
    doRowClicked(event, isOn) {
      if (!event || !event.data) return
      this.audit.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.audit.selectedData = node
        // 根据业务查询对应费用数据
        if (this.selectShow.nowJob !== this.audit.selectedData.jobUuid && isOn) {
          this.queryChargeListHandler(this.audit.selectedData.jobUuid)
        }
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.audit.selectedFiles.push(event.data)
      } else {
        this.audit.selectedFiles = this.audit.gridApi.getSelectedRows()
      }
      this.doRowClicked(event, false)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.audit.selectedData = {}
      if (this.audit.gridApi) {
        this.audit.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.audit.selectedData = f
            }
          }
        })
      }
    },
    // 加载费用
    queryChargeListHandler(jobUuid) {
      this.selectShow.rowData = []
      loadChargesFunc({ jobUuid }).then(res => {
        this.selectShow.nowJob = jobUuid
        this.selectShow.rowData = res.data
      })
    },
    showBusinessInfo(e) {
      if (!this.audit.selectedData) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.audit.selectedData)
      this.templateSelectorDialog.category = 'JOB_DETAIL'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.audit.selectedData.jobUuid }
      this.templateSelectorDialog.visible = true
    },
    // 打印付款清单
    printClickHandler() {
      const rows = this.audit.gridApi.getSelectedRows()
      const list = []
      for (const c of rows) {
        if (c.payable) {
          list.push(c.uuid)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('Message.ThereAreNoPayableBillsToPrint'))
        return
      }
      const params = {}
      params.DOC_UUID = Array.from(list, p => p.uuid)
      this.templateSelectorDialog.category = 'CargoDocList'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 打印结算单位
    printCompanyClickHandler(companyUuid) {
      if (!companyUuid) {
        return
      }
      const params = {}
      params.DOC_UUID = [companyUuid]
      this.templateSelectorDialog.category = 'PARTNER'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 审核
    btnAuditClickHandler() {
      const rows = this.audit.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const jobNos = []
      for (const singleRelease of rows) {
        // ReleaseState 等于 待审核 或者 已扣单
        if (singleRelease.releaseState === NOTSINGLERELEASE.code || singleRelease.releaseState === BUCKLERELEASE.code) {
          jobNos.push(singleRelease.jobNo)
        }
      }
      if (jobNos != null && jobNos.length > 0) {
        this.loading = getLoading()
        checkCustomsBlackName(jobNos).then(res => {
          if (res.data) {
            this.$message.warning('数据中含有黑名单客户，不可放单！')
          } else {
            const docKeys = []
            for (const singleRelease of rows) {
              docKeys.push(singleRelease.uuid)
            }
            this.loadCargoDocKeyHandler(docKeys, this.$t('CargoMsg.Cargo_Audit'), [NOTSINGLERELEASE.code, BUCKLERELEASE.code], MODE_AUDIT.code)
          }
        }).catch(err => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.$message.warning(this.$t('Message.NoDataToAudit'))
        return
      }
    },
    // 取消审核
    btnCancelAuditClickHandler() {
      const rows = this.audit.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const docKeys = []
      for (const singleRelease of rows) {
        docKeys.push(singleRelease.uuid)
      }
      this.loadCargoDocKeyHandler(docKeys, this.$t('CargoMsg.Cargo_RevokeReview'), [SINGLERELEASE.code])
    },
    // 扣单
    btnDetainClickHandler() {
      const rows = this.audit.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const docKeys = []
      for (const singleRelease of rows) {
        docKeys.push(singleRelease.uuid)
      }
      this.loadCargoDocKeyHandler(docKeys, this.$t('CargoMsg.Cargo_HoldDoc'), [NOTSINGLERELEASE.code])
    },
    // 特批放单
    async btnSpecialApprovalClickHandler() {
      const rows = this.audit.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const docKeys = []
      for (const singleRelease of rows) {
        const days = await JobUtils.checkEtdDaysCreditInfo(singleRelease.customerId, 2)
        // 只处理4-待收款，0-待审核， 10-已扣单的数据
        if ([0, 10, 4].indexOf(singleRelease.releaseState) === -1 && days === -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AutomaticReleaseTips'))
          return
        }
        docKeys.push(singleRelease.uuid)
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmR') + this.$t('CargoMsg.Cargo_SpecialApprovalOrder'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        specialApprovalOrder(docKeys).then(res => {
          this.loading.close()
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
          this.toQueryByPage()
        }).catch(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 根据uuid和放单审核加载cargoDoc
    loadCargoDocKeyHandler(docKeys, auditMsg, status, flag) {
      this.loading = getLoading()
      const requestBody = {
        status: status,
        uuids: docKeys
      }
      loadCargoDocKeysByReleaseReview(requestBody).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this.$t('Message.NoDataToAudit2', [auditMsg]))
          return
        }
        // 扣单单独处理
        if (auditMsg === this.$t('CargoMsg.Cargo_HoldDoc')) {
          this.withOldWindow.visible = true
          this.withOldWindow.list = res.data
        } else {
          this.$confirm(this.$t('Message.AreYouSureYouWantTo', [auditMsg]), this.$t('common.tips.confirm'), {
            confirmButtonText: this.$t('common.btn.yes'),
            cancelButtonText: this.$t('common.btn.no'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(async() => {
            if (flag === MODE_AUDIT.code) {
              await this.doCheckNodeAndSave(auditMsg, res.data, '') // 审核需要走验证
            } else {
              this.queryReleaseReviewDocsHandler(auditMsg, res.data, '') // 撤销审核不用走验证
            }
          })
        }
      }).catch((err) => {
        this.$message.error(err)
      }).finally((e) => {
        this.loading.close()
      })
    },
    async doCheckNodeAndSave(auditMsg, list, r) {
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      let flag = false
      if (useCheckRule) {
        await JobUtils.queryByNode(CheckRuleConstants.NODE_RELEASE_ORDER_REVIEW_DELEGATION.code, this.$store.getters.currentOfficeId).then(res => {
          // 遍历 data 数组
          for (const item of res) {
            if (item.checkCriteria && item.checkCriteria.length > 0) {
              item.checkCriteria.forEach((criteria) => {
                if (criteria.filterValue === CheckRuleConstants.SLAVE_ORDER.code && criteria.operator === CheckRuleConstants.EQUAL.code) {
                  flag = true
                } else if (criteria.filterValue === CheckRuleConstants.MASTER_ORDER.code && criteria.operator === CheckRuleConstants.NOT_EQUAL.code) {
                  flag = true
                }
              })
            }
          }
        })
        if (flag) {
          const rows = this.audit.gridApi.getSelectedRows()
          const callBack = () => {
            this.queryReleaseReviewDocsHandler(auditMsg, list, r)
          }
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_RELEASE_ORDER_REVIEW_DELEGATION.code
          this.batchCheckingWindow.jobs = rows
          this.batchCheckingWindow.allowPartialCheckPass = true
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = null
          this.batchCheckingWindow.visible = true
        } else {
          this.queryReleaseReviewDocsHandler(auditMsg, list, r)
        }
      } else {
        await this.queryReleaseReviewDocsHandler(auditMsg, list, r)
      }
    },
    queryReleaseReviewDocsHandler(auditMsg, list, r) {
      try {
        this.loading = getLoading()
        this.sopJobs = []
        const docKeys = []
        for (const doc of list) {
          this.sopJobs.push(doc.jobUuid)
          docKeys.push(doc.uuid)
        }
        const param = {}
        param['docKeys'] = docKeys
        const date = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        if (auditMsg === this.$t('CargoMsg.Cargo_Audit')) {
          param['releaseState'] = SINGLERELEASE.code
          param['reviewDate'] = date
          param['withhold'] = false
          param['operation'] = CARGODOC_CAN_SINGLE_RELEASE
        } else if (auditMsg === this.$t('CargoMsg.Cargo_RevokeReview')) {
          param['releaseState'] = NOTSINGLERELEASE.code
          param['reviewDate'] = ''
          param['operation'] = CARGODOC_CANCEL_APPROVE
        } else if (auditMsg === this.$t('CargoMsg.Cargo_HoldDoc')) {
          param['releaseState'] = BUCKLERELEASE.code
          param['withhold'] = true
          param['withholdDate'] = date
          param['withholdReason'] = r
          param['operation'] = CARGODOC_DETAIN
        }
        const requestBody = {
          paramValue: param,
          uuids: docKeys
        }
        batchAuditSingleReleaseHbl(requestBody).then(res => {
          const result = res.data
          if (result.count) {
            this.$message.success(this.$t('CargoMsg.Cargo_Success') + auditMsg + result.count + this.$t('CargoMsg.Cargo_DataBar'))
          }
          this.toQueryByPage()
          if (this.sopJobs.length > 0 && auditMsg === this.$t('CargoMsg.Cargo_Audit')) {
            // 触发sop
            trackingApi.batchUpdateTrackingByEvent(this.sopJobs, EX_MBL_EXAMINE.code)
          }
          if (result.releaseRules && result.releaseRules.length > 0) {
            this.releaseRuleResultWindow.visible = true
            this.releaseRuleResultWindow.releaseRules = result.releaseRules
          }
        })
      } finally {
        this.loading.close()
      }
    },
    saveWithholdReasonHandler(event) {
      this.queryReleaseReviewDocsHandler(this.$t('CargoMsg.Cargo_HoldDoc'), event.list, event.remark)
    },
    // 更新备注 或 扣货原因
    changeReleaseReviewHandler(event) {
      if (event && event.data) {
        const d = event.data
        const docList = []
        docList.push(d)
        updateChargeAndDocFunc(docList, { num: 2 }).then(res => {
        })
      }
    },
    guaranteeFileDialogHandler(job, ifLongGuaranteeState = false) {
      if (ifLongGuaranteeState) {
        this.longTermGuaranteeFileDialog.visible = true
        this.longTermGuaranteeFileDialog.uuid = job.longTermGuaranteeUuid
      } else {
        const params = {}
        params.jobUuid = job.jobUuid
        params.jobNo = job.jobNo
        params.docUuid = job.uuid
        params.hbl = job.hblNo
        params.uuid = job.jobUuid
        params.documentType = ExternalFileType.HBL_SINGLE_TICKET_GUARANTEE.code
        params.documentCategory = job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? DocumentConstants.SINGLE_TICKET_GUARANTEE_SPLIT.code : job.typeHBL === BillType.MERGE_BILL_TYPE.code ? DocumentConstants.SINGLE_TICKET_GUARANTEE_MERGE.code : DocumentConstants.SINGLE_TICKET_GUARANTEE_NORMAL.code
        this.guaranteeFileDialog.model = params
        this.guaranteeFileDialog.ifLongGuaranteeState = ifLongGuaranteeState
        this.guaranteeFileDialog.visible = true
      }
    },
    initCustomSearchItems() {
      this.customSearchItems = ColumnUtils.getBlModeList(BlModeType.HBL.code)
      if (this.arWriteOffStatusQuerySearch) {
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'job._JOB_PAIDOFF_TRUE_'
        searchField.itemLabel = 'CargoMsg.Cargo_ReceivablesWriteOfStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = 'SystemConstants.RECEIVABLE'
        searchField.dataCacheKey = 'local_cache_SystemConstants$RECEIVABLE'
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      this.searchItemAutoInit = true
      return this.customSearchItems
    },
    async initColumnDefs() {
      // 加载SOP显示
      const sopColumns = await SopUtil.getSopColumns('SE')
      // 加载保函配置
      const resp = await queryReleaseGuaranteeList()
      let guaranteeConfigEnable = false
      if (resp.data && resp.data.length > 0) {
        const currentOfficeId = this.$store.getters.currentOfficeId
        guaranteeConfigEnable = resp.data.some(item => {
          if (!item.status) return false
          // 将branchId转换为数值数组
          const branchIds = item.branchId ? item.branchId.split(',').map(id => Number(id)) : []
          // 检查当前分公司是否在配置的分公司列表中
          return branchIds.includes(currentOfficeId)
        })
      }
      if (guaranteeConfigEnable) {
        this.columnDefs = [...this.columnDefs, ...sopColumns, ...this.guaranteeColumnDef]
      } else {
        this.columnDefs = [...this.columnDefs, ...sopColumns]
      }
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
}
</style>
